/* eslint-disable camelcase */
import React, { useState, useEffect } from "react"
import Header from "../../../layouts/Header"
import { styled, createTheme, ThemeProvider } from "@mui/material/styles"
import { Box, InputLabel, Select, MenuItem, TextField, Button, Tooltip } from "@mui/material"
import Swal from "sweetalert2"
import { useQuery, useQueryClient, useMutation } from "@tanstack/react-query"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import BackIcon from "../../../components/BackIcon"
import GrabarIcon from "../../../assets/iconos/Grabar.ico"
import fetchwrapper from "../../../services/interceptors/fetchwrapper"
import CustomBackdrop from "../../../components/CustomBackdrop"
import ImprimirIcon from "../../../assets/iconos/Impresion.ico"
import DetalleImpresion from "../components/DetalleImpresion"
import ZonasPDF from "../components/ZonasPdf"
const StyledRoot = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  marginTop: theme.spacing(8),
  flexGrow: 1,
  padding: "0 16px",
  height: "100vh",
}))
const theme = createTheme({
  palette: {
    primary: {
      main: "#196C87",
    },
    secondary: {
      main: "#196C87", // Cambia el color secundario a verde azulado
    },
  },
})
const EditarZona = () => {
  const { id } = useParams()
  const location = useLocation()
  const datoSeleccionado = location.state
  const estadoActual = datoSeleccionado.izonstatus
  const descripcionActual = datoSeleccionado.izondescripcion
  const tipoActual = datoSeleccionado.izontipo
  const navigate = useNavigate()
  const [openModal, setOpenModal] = useState(false)
  const [infoGenerada, setInfoGenerada] = useState([])
  const handleOpenModal = () => {
    const datos = getDatosActuales()
    console.log("datos", datos)
    setInfoGenerada(datos) // Asigna los datos de la tabla al estado
    setOpenModal(true)
  }

  const handleCloseModal = () => {
    setOpenModal(false)
    navigate(`/home/dashboard/Zonas`)
  }
  function getDatosActuales() {
    return [
      {
        izoncodigo: id,
        izondescripcion: descripcionActual,
        izonstatus: estadoActual,
        izontipo: tipoActual,
      },
    ]
  }
  // Valores por defectos para los comboboxes y el check
  const Estados = [
    { value: "A", description: "ACTIVO" },
    { value: "I", description: "INACTIVO" },
  ]
  const TipoZona = [
    { value: "A", description: "ALMACENAMIENTO" },
    { value: "D", description: "DESCARGA" },
    { value: "C", description: "CUARENTENA" },
    { value: "P", description: "PICKING" },
  ]
  const findEstado = (estadoCurrent) => {
    const result = Estados.find((estado) => estado.value === estadoCurrent)
    return result
  }
  const findTipo = (tipoCurrent) => {
    const result = TipoZona.find((tipo) => tipo.description === tipoCurrent)
    console.log("zona actual", result)
    return result
  }

  // Estados para manejaar el formulario de opciones
  // cuando llame a las funciones set, se actualizara el valor de los otros campos y se re renderiza
  const [codigo, setCodigo] = useState(id)
  const [descripcion, setDescripcion] = useState(descripcionActual)
  const [estado, setEstado] = useState(findEstado(estadoActual))
  const [tipoZona, setTipoZona] = useState(findTipo(tipoActual))

  const { mutateAsync: updateZona, isPending: isUpdatingZona } = useUpdateZona()

  function useUpdateZona() {
    const queryClient = useQueryClient()
    return useMutation({
      mutationFn: async (zona) => {
        // send api update request here
        // send api update request here
        const options = {
          method: "PUT",
          body: JSON.stringify(zona),
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        }
        console.log("json", options.body)
        let response = await fetchwrapper(`/Zonas/editZona/${id}`, options)

        response = await response.json()
        console.log(response)
        return response
      },
      // client side optimistic update
      onMutate: (newZona) => {
        console.log(newZona, "onmutate")
        queryClient.setQueryData(["zona", id], (prevZona) => ({
          ...newZona,
        }))
      },
      // onSettled: () => queryClient.invalidateQueries({ queryKey: ['bancoDePreguntas'] }), //refetch bancoDePreguntas after mutation, disabled for demo
    })
  }
  const handleSubmit = async (e) => {
    e.preventDefault()
    console.log("ejecutando handle submit")
    try {
      const zona = {
        tipo_zona: tipoZona.description,
        descripcion_zona: descripcion,
        estado_zona: estado.value,
      }
      await updateZona(zona)
      Swal.fire({
        icon: "success",
        title: "Operación exitosa",
        text: "Se pudo editar la zona",
      }).then((result) => {
        if (result.isConfirmed) {
          navigate("/home/dashboard/Zonas") // Navegar a la ruta especificada
        }
      })
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: "No se pudo crear la zona",
        icon: "error",
        confirmButtonText: "OK",
      }).then(() => {
        navigate("/home/dashboard/Zonas") // Navega de vuelta cuando se cierre el SweetAlert
      })
    }
  }
  return (
    <ThemeProvider theme={theme}>
      <Header />
      <div className="main main-app p-3 p-lg-4">
        <BackIcon />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0 30px 30px 30px",
            fontSize: "25px",
          }}
        >
          <b>Zonas</b>
        </div>
        <Box className={StyledRoot}>
          <form onSubmit={handleSubmit}>
            <Tooltip title="Grabar">
              <Button type="submit" color="primary" sx={{ marginTop: "15px" }}>
                <img src={GrabarIcon} alt="Grabar" style={{ width: "30px" }} />
              </Button>
            </Tooltip>
            <Tooltip title="Imprimir">
              <Button color="primary" onClick={handleOpenModal} sx={{ marginTop: "15px" }}>
                <img src={ImprimirIcon} alt="Imprimir" style={{ width: "30px" }} />
              </Button>
            </Tooltip>
            <DetalleImpresion
              open={openModal}
              handleClose={handleCloseModal}
              infoGenerada={getDatosActuales()}
              nombrePdf={"Zona"}
              PdfComponent={ZonasPDF}
            />
            <TextField
              label="Código"
              margin="normal"
              fullWidth
              value={codigo}
              disabled
              required
              sx={{
                backgroundColor: "#e2dbd8",
              }}
            />
            <TextField
              label="Descripción"
              margin="normal"
              fullWidth
              value={descripcion}
              onChange={(e) => setDescripcion(e.target.value)}
              required
            />
            <div>
              <InputLabel id="tiposZonasCB" sx={{ paddingBlock: "15px", paddingLeft: "5px" }}>
                Tipo de Zona
              </InputLabel>
              <Select
                fullWidth
                labelId="tiposZonasCB"
                value={tipoZona.value}
                onChange={(e) => {
                  const selectedValue = e.target.value
                  const tipoZona = TipoZona.find((tipoZona) => tipoZona.value === selectedValue)
                  setTipoZona(tipoZona)
                  //   clearAll(tipoPregunta)
                }}
              >
                {TipoZona.map((tipo) => (
                  <MenuItem key={tipo.value} value={tipo.value}>
                    {tipo.description}
                  </MenuItem>
                ))}
              </Select>
            </div>
            <div>
              <InputLabel id="estadoZonasCB" sx={{ paddingBlock: "15px", paddingLeft: "5px" }}>
                Estado de la zona
              </InputLabel>
              <Select
                fullWidth
                labelId="estadoZonasCB"
                value={estado.value}
                onChange={(e) => {
                  const selectedValue = e.target.value
                  const zonaestado = Estados.find((estado) => estado.value === selectedValue)
                  setEstado(zonaestado)
                  //   clearAll(tipoPregunta)
                }}
              >
                {Estados.map((estado) => (
                  <MenuItem key={estado.value} value={estado.value}>
                    {estado.description}
                  </MenuItem>
                ))}
              </Select>
            </div>
          </form>
        </Box>
        <CustomBackdrop isLoading={isUpdatingZona} />
      </div>
    </ThemeProvider>
  )
}

export default EditarZona
